export default "__VITE_ASSET__7920414b__"